import { z } from "zod/v4"
import { UserDenormalizedWithLook } from "./user"
import { SpaceDocument } from "./space"
import { LiveDocument } from "./live"

export const LiveForSearchDocument = z.object({
  space_key: z.string(),
  live_id: z.string(),
  owner_id: z.string().describe("スペースのオーナーID"),
  genre_id: z.string().describe("ジャンルID"),
  tags: z.array(z.string()),

  space: z.object({
    name: z.string(),
    // 必要に応じて非正規化していく
  }),

  owner: UserDenormalizedWithLook,
}).describe("検索(Algolia)用に非正規化しているライブ情報")

export type LiveForSearchDocument = z.infer<typeof LiveForSearchDocument>

export class LiveForSearchDocuments {
  static build(
    live: LiveDocument,
    space: SpaceDocument,
    owner: UserDenormalizedWithLook,
  ): LiveForSearchDocument {
    return {
      space_key: space.id,
      live_id: live.id,
      owner_id: owner.id,
      genre_id: live.genre_id,
      tags: live.tags ?? [],

      space: {
        name: space.name,
      },

      owner
    }
  }
}
